import { render, staticRenderFns } from "./ExtendedCountdownSetting.vue?vue&type=template&id=12985df8&"
import script from "./ExtendedCountdownSetting.vue?vue&type=script&lang=ts&"
export * from "./ExtendedCountdownSetting.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendedCountdownSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports